const LOCAL_STORAGE_ITEM = "projectDashboard";
export const PROJECT_BANNER_HEIGHT = 48;

export const setLocalDashboardData = (dashboardTitle: string) => {
    localStorage.setItem(LOCAL_STORAGE_ITEM, JSON.stringify({ dashboardTitle }));
};

export const removeLocalDashboardData = () => {
    localStorage.removeItem(LOCAL_STORAGE_ITEM);
};
